/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Media_Files_SelectedInputs */

const en_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No media files selected`)
};

const fr_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun fichier multimédia sélectionné`)
};

const de_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Mediendateien ausgewählt`)
};

const it_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun file multimediale selezionato`)
};

const ru_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиафайлы не выбраны`)
};

const es_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay archivos multimedia seleccionados`)
};

const zh_cn2_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何媒体文件`)
};

const ja_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルが選択されていません`)
};

const hi_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई मीडिया फ़ाइल चयनित नहीं है`)
};

const pt_pt2_no_media_files_selected = /** @type {(inputs: No_Media_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum arquivo de mídia selecionado`)
};

/**
* | output |
* | --- |
* | "No media files selected" |
*
* @param {No_Media_Files_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_media_files_selected = /** @type {((inputs?: No_Media_Files_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Media_Files_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_media_files_selected(inputs)
	if (locale === "de") return de_no_media_files_selected(inputs)
	if (locale === "it") return it_no_media_files_selected(inputs)
	if (locale === "ru") return ru_no_media_files_selected(inputs)
	if (locale === "es") return es_no_media_files_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_no_media_files_selected(inputs)
	if (locale === "ja") return ja_no_media_files_selected(inputs)
	if (locale === "hi") return hi_no_media_files_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_no_media_files_selected(inputs)
	return en_no_media_files_selected(inputs)
});